import type { TEnvConfig, TAppEnvironment } from './env.config.types';
import type { TABTestConfig } from '@/hooks/ab-test/ab-test.types';

const parseABTestConfig = (raw: string): TABTestConfig => {
	try {
		return JSON.parse(raw) as TABTestConfig;
	} catch {
		return {};
	}
};

const getAuthEnv = (): TEnvConfig['AUTH_ENV'] => {
	const authEnv = import.meta.env.VITE_AUTH_ENV;

	if (!authEnv) {
		throw new Error('VITE_AUTH_ENV is required. Check your .env file.');
	}

	return authEnv as TEnvConfig['AUTH_ENV'];
};

const ENV: TEnvConfig = {
	APP_ENV: (import.meta.env.VITE_APP_ENV ?? 'development') as TAppEnvironment,
	AUTH_ENV: getAuthEnv(),
	URL_LOGIN: import.meta.env.VITE_URL_LOGIN ?? '',
	URL_PORTAL: import.meta.env.VITE_URL_PORTAL ?? 'https://hportal.webmotors.com.br',
	URL_BUY: import.meta.env.VITE_URL_BUY ?? 'https://hportal.webmotors.com.br/comprar/',
	URL_SELL: import.meta.env.VITE_URL_SELL ?? 'https://hportal.webmotors.com.br/vender-carro',
	API_BASE_URL: import.meta.env.VITE_API_BASE_URL ?? 'https://hportal.webmotors.com.br/api/',
	API_UPLOAD_URL: import.meta.env.VITE_API_UPLOAD_URL ?? 'https://hportal.webmotors.com.br/upload/onupload',
	API_IMAGE_URL: import.meta.env.VITE_API_IMAGE_URL ?? 'https://himage.webmotors.com.br/_fotos/anunciousados/gigante/',
	AB_TEST_ENABLED: import.meta.env.VITE_AB_TEST_ENABLED === 'true',
	AB_TEST_CONFIG: parseABTestConfig(import.meta.env.VITE_AB_TEST_CONFIG ?? '{}'),
	DATADOG_CLIENT_TOKEN: import.meta.env.VITE_DATADOG_CLIENT_TOKEN ?? '',
	DATADOG_APPLICATION_ID: import.meta.env.VITE_DATADOG_APPLICATION_ID ?? '',
	DATADOG_SERVICE: import.meta.env.VITE_DATADOG_SERVICE ?? 'wm-my-ads-ui',
	DATADOG_SITE: import.meta.env.VITE_DATADOG_SITE ?? 'datadoghq.com',
	DATADOG_ENV: import.meta.env.VITE_DATADOG_ENV ?? 'development',
	DATADOG_SESSION_SAMPLE_RATE: Number(import.meta.env.VITE_DATADOG_SESSION_SAMPLE_RATE ?? 20),
	DATADOG_SESSION_REPLAY_SAMPLE_RATE: Number(import.meta.env.VITE_DATADOG_SESSION_REPLAY_SAMPLE_RATE ?? 20),
	THREATMETRIX_ORG_ID: import.meta.env.VITE_THREATMETRIX_ORG_ID ?? '1snn5n9w',
	THREATMETRIX_MERCHANT_ID: import.meta.env.VITE_THREATMETRIX_MERCHANT_ID ?? 'webmotors'
} as const;

export { ENV };
